import styled from 'styled-components';

export const FiltersModalActions = styled.div`
  padding-top: 25px;
  text-align: center;
`;
